import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { Modal, Button, Form, Tab, Message, Confirm } from "semantic-ui-react";
import PropTypes from "prop-types";
import GuestSearchDropDown from "../shared/GuestSearchDropDown";
import RoomTypesDropDown from "../shared/RoomTypesDropDown";
import RoomsDropDown from "../shared/RoomsDropDown";
import CustomerDropDown from "../shared/CustomerDropDown";
import ProductsDropDown from "../shared/ProductsDropDown";
import ReservationSourcesDropDown from "../shared/ReservationSourcesDropDown";
import { onSuccess, onError, onWarning } from "../shared/messages";
import {
  SaveReservation,
  GetDefaultReservationValues,
  CalculateTotalAmountCurrentReservation,
} from "../../api/services/pms";
import { endpoint } from "../../api/http";
import PricingTypesDropDown from "../shared/PricingTypesDropdown";
import formatCurrency from "format-currency";
import { Currencies } from "../shared/currencies";
import _ from "lodash";
import { useMessageResources, useTextResources } from "../../language";
import { DatePicker, TimePicker } from "../shared/DatePicker";
import moment from "moment";
import CurrencyInput from "../shared/CurrencyInput";
import NumericInput from "../shared/NumericInput";
import { GetHotelParameters } from "../../api/services/organization";
import { GetCustomers, GetGuests } from "../../api/services/crm";
import {
  RebuildReservation,
  CleanReservationProps,
  RecalcReservationForFixedPricesPaxChange,
  GetSingleReservation,
} from "../../Utils/reservation";
import { checkEmailValid, useLoader } from "../shared/utils";
import { HtmlEditor } from "../shared/HtmlEditor";
import NationalitiesDropDown from "../shared/NationalitiesDropDown";
import HotelsDropDown from "../shared/HotelsDropDown";
import { isMobileOnly } from "mobile-device-detect";
import "./styles.css";
import {
  PermissionsActions,
  UserHasPermission,
} from "../shared/permissionsActions";
import {
  ReservationAmountOverrideType,
  HotelFeatureCodes,
  dateFormat
} from "../shared/constants";
import { PaymentDialog } from "../Payment/paymentDialog";
import saveAs from "file-saver";
import ClubMemberIcon from "../shared/ClubMemberIcon";
import { Guests } from "../../api/services/next";
import { useCurrentHotel } from "../../hooks/useCurrentHotel";
import { IconButton } from "@material-ui/core";
import { Clubs } from "../../api/services/next";
import { LocalActivity } from "@material-ui/icons";
import { defaultAllowedPaymentProviderIDs } from '../Payment/paymentCommon';

const ShortReservationPopup = ({
  onClose,
  reservation: initialReservation,
  onSave,
  ...rest
}) => {
  const text = useTextResources();
  const message = useMessageResources();
  const loader = useLoader();
  const [reservation, setReservation] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const [isRecalculating, setIsReCalculating] = useState(false);
  const [businessDate, setBusinessDate] = useState(new Date());
  const [agent, setAgentItem] = useState(null);
  const [company, setCompanyItem] = useState(null);
  const [guest, setGuestObj] = useState(null);
  const [confirmNewGuestElement, setConfirmNewGuestElement] = useState(null);
  const paymentDialogRef = useRef();
  const [defaults, setDefaults] = useState();
  const [hotelParams, setHotelParams] = useState([]);
  const [discountPercent, setDiscountPercent] = useState(0);
  const [clubMemberDetails, setClubMemberDetails] = useState();
  const [clubMemeberFeature, setClubMemberFeature] = useState(false);
  const [clubMemberPopup, setclubMemberPopup] = useState(null);
  const [checkingSpan, setCheckingSpan] = useState(false);
  const currentHotel = useCurrentHotel();
  const [displaySave, setDisplaySave] = useState(true);
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const savedReservationRef = useRef(null);

  const hotel = reservation && reservation._hotel;
  const hotelid = initialReservation?.HotelId || reservation?.HotelId;
  const defaultNationalityId = useMemo(
    () =>
      hotelParams?.CurrentHotel?.[0]?.HotelParameter?.DefaultGuestNationalityID,
    [hotelParams]
  );

  useEffect(() => {
    setBusinessDate(new Date());
    setDisplaySave(true);

    if (
      currentHotel.HotelFeatures?.find(
        (x) => x.FeatureID === HotelFeatureCodes.ClubMember
      )
    )
      setClubMemberFeature(true);
  }, []);

  useEffect(() => {
    setDisplaySave(true);
  }, []);


  useEffect(() => {
    if (_.isEmpty(initialReservation)) return;

    setActiveTabIndex(0); // Reset tab to first on every open

    if (!initialReservation.Id) {
      initializeReservation();
    } else {
      setAgentItem(initialReservation.Agent);
      setCompanyItem(initialReservation.Company);
      setGuestItem(initialReservation.Guest);
      setReservation({
        ...initialReservation,
        CheckInDate: moment(initialReservation.CheckInDate)
          .startOf("day")
          .toDate(),
        CheckOutDate: moment(initialReservation.CheckOutDate)
          .startOf("day")
          .toDate(),
        RefetchReservation: true,
      });
    }
  }, [initialReservation]);

  useEffect(() => {
    if (_.isEmpty(reservation)) return;

    if (
      reservation.RoomTypeId &&
      reservation.ProductId &&
      reservation.CheckInDate &&
      reservation.CheckOutDate
    ) {
      calc(reservation, false);
    } else {
      setReservation((prev) => {
        return {
          ...prev,
          TotalAmountProductCurrentBeforeTax: null,
          TotalAmountProductCurrentAfterTax: null,
        };
      });
    }
  }, [
    reservation.HotelId,
    reservation.Adults,
    reservation.Children,
    reservation.Infants,
    reservation.RoomTypeId,
    reservation.CheckInDate,
    reservation.CheckOutDate,
    reservation.ProductId,
    reservation.ReservationPricingTypeId,
  ]);

  const setGuestItem = (item) => {
    (async () => {
      if (item && guest && item.Id === guest.Id) {
        setGuestObj((prev) => {
          return {
            ...prev,
            ...item,
          };
        });
      } else {
        if (item?.Id && !item.Id?.toString().startsWith("newguest-")) {
          var result = await Guests.GetGuests({
            Id: item.Id,
            Includes: ["GuestClubs"],
          });
          let guestClub = result[0]?.GuestClubs[0];
          if (guestClub != null) {
            const clubs = await Clubs.GetClubs({ IsActive: true });
            guestClub.Club = clubs[0];
            setClubMemberDetails(guestClub);
            item.GuestClubs = [guestClub];
          } else {
            setClubMemberDetails(null);
          }
        }
        setGuestObj(item);
      }
    })();
  };
  const setGuesuClub = (club) => {
    setGuestObj((prevState) => ({
      ...prevState,
      GuestClubs: [club],
    }));
    const updated = guest
      ? {
        ...guest,
        GuestClubs: [club],
        Updated: true,
      }
      : { GuestClubs: club };
    setReservation((prev) => ({
      ...prev,
      Guest: updated,
    }));
  };
  const CheckClubMember = ({ currentTarget }) => {
    try {
      (async () => {
        // setCheckingSpan(true);
        if (
          clubMemeberFeature &&
          (currentTarget.value || guest?.IdentityCardNumber)
        ) {
          const guestIdentity =
            currentTarget.value || guest?.IdentityCardNumber;
          const result = await Guests.CheckClubMember({
            Id: typeof guest?.Id != 'string' ? guest?.Id : 0,
            IdentityCardNumber: guestIdentity,
            Includes:[
              'ClubMembership',
              'GuestClubs'
            ]
          })

          if (result?.GuestClubs?.length > 0) {
            const clubs = await Clubs.GetClubs({ IsActive: true });
            result.GuestClubs[0].Club = clubs[0];
            result.GuestClubs[0].ClubId = clubs[0].Id;

            setClubMemberDetails(result.GuestClubs[0]);
            setGuesuClub(result?.GuestClubs[0]);
            await clubResultPopup(result.GuestClubs[0]);
          }
          else {
            setClubMemberDetails(null);
            await clubResultPopup(null);
          }
        }
        else {
          setClubMemberDetails(null);
        }
      })();
    } catch (error) {
      onError(error);
    } finally {
      setCheckingSpan(false);
    }
  };
  const clubResultPopup = (clubDetails) => {
    return new Promise((resolve) => {
      setclubMemberPopup(
        <Modal {...rest} size="tiny">
          <Modal.Content>
            {clubDetails && (
              <div
                style={{
                  textAlign: "center",
                  padding: "10px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "10px",
                  }}
                >
                  <span style={{ margin: "0 5px" }}>
                    {clubDetails.Club.Name}
                  </span>
                  <span style={{ margin: "0 5px" }}>:</span>
                  <span style={{ margin: "0 5px" }}>
                    {clubDetails.Description}
                  </span>
                  <span style={{ margin: "0 5px" }}>:</span>
                  <span style={{ margin: "0 5px", order: 1 }}>
                    {moment(clubDetails.EnrollmentDate).format(dateFormat)} -{" "}
                    {moment(clubDetails.EndDate).format(dateFormat)}
                  </span>
                </div>
                <p style={{ margin: 0 }}>{message("CheckClubMemberDates")}</p>
              </div>
            )}
            {!clubDetails && (
              <div>
                <p>{message("GuestMemberNotFound")}</p>
              </div>
            )}
          </Modal.Content>
          <Modal.Actions>
            <Button
              size="small"
              onClick={() => {
                resolve(false);
                setclubMemberPopup(null);
              }}
            >
              {text("Close")}
            </Button>
          </Modal.Actions>
        </Modal>
      );
    });
  };

  const initializeReservation = async () => {
    try {
      loader(true);
      // Reset Guest
      setGuestObj(null);
      const defaultReservation = {};
      const hotelDefaults = await GetDefaultReservationValues({
        HotelId: hotelid,
        IncludeAllProductRestrictions: UserHasPermission(
          PermissionsActions.SelectOnlyUnrestrictedProduct
        ),
      });
      const hotelParams = await GetHotelParameters({ ID: hotelid });
      setHotelParams(hotelParams);
      _.mergeWith(
        defaultReservation,
        _.pick(
          hotelDefaults.HotelDefaultReservationValuesViewModel,
          "Adults",
          "Children",
          "Infants",
          "AgentID",
          "CompanyID",
          "PaymentTypeID",
          "Nights"
        ),
        (a, b) => (b ? b : a)
      );

      /*Temp fix for defaults retrieved on CMP's initialization from OP2
       with incorrect capitalization.*/
      defaultReservation.CompanyId = defaultReservation.CompanyID;
      defaultReservation.AgentId = defaultReservation.AgentID;
      defaultReservation.CompanyID = defaultReservation.AgentID = undefined;

      const defaultProducts =
        hotelDefaults.HotelDefaultReservationProductsViewModel;
      const product = _.find(defaultProducts, [
        "RoomTypeId",
        initialReservation.RoomTypeId,
      ]);
      if (product) {
        defaultReservation.ProductId = product.ProductID;
        defaultReservation.CurrencyId = product.Currency.Id;
      }
      if (!initialReservation.Eta || !initialReservation.Edt) {
        if (
          hotelParams &&
          hotelParams.CurrentHotel &&
          hotelParams.CurrentHotel.length
        ) {
          defaultReservation.Eta = hotelParams.CurrentHotel[0].Eta || "14:00";
          defaultReservation.Edt =
            hotelParams.CurrentHotel[0].HotelParameter.Etd || "11:00";
        } else {
          defaultReservation.Eta = "14:00";
          defaultReservation.Edt = "11:00";
        }
      }

      if (!initialReservation.CheckInDate || !initialReservation.CheckOutDate) {
        defaultReservation.CheckInDate = moment().toISOString();
        defaultReservation.CheckOutDate = moment()
          .add(defaultReservation.Nights ?? 1, "days")
          .toISOString();
      }

      if (defaultReservation.AgentId) {
        const customers = await GetCustomers({
          "Ids[0]": defaultReservation.AgentId,
          IncludeCustomerProductCommission: true,
          GetOnlyCustomerArray: true,
        });
        if (customers && customers.length) {
          defaultReservation.Agent = customers[0];
          if (defaultReservation.Agent) {
            defaultReservation.PaymentArrangementId =
              defaultReservation.Agent.DefaultPaymentArrangementID;
            defaultReservation.ReservationSourceID =
              defaultReservation.Agent.DefaultReservationSourceID;
            defaultReservation.MarketSegmentID =
              defaultReservation.Agent.DefaultReservationMarketSegmentID;
          }
        }
      } else if (defaultReservation.CompanyId) {
        const customers = await GetCustomers({
          "Ids[0]": defaultReservation.CompanyId,
          IncludeCustomerProductCommission: true,
          GetOnlyCustomerArray: true,
        });
        if (customers && customers.length) {
          defaultReservation.Company = customers[0];
          if (defaultReservation.Company) {
            defaultReservation.PaymentArrangementId =
              defaultReservation.Company.DefaultPaymentArrangementID;
            defaultReservation.ReservationSourceID =
              defaultReservation.Company.DefaultReservationSourceID;
            defaultReservation.MarketSegmentID =
              defaultReservation.Company.DefaultReservationMarketSegmentID;
          }
        }
      }
      if (defaultNationalityId) {
        defaultReservation.Guest = {
          NationalityId: defaultNationalityId,
        };
        setGuestItem({
          NationalityId: defaultNationalityId,
          Updated: true,
        });
      }
      //If hotel-reservation doesn't have default PAX distribution, assign the below
      defaultReservation.Adults ??= 2;
      defaultReservation.Children ??= 0;
      defaultReservation.Infants ??= 0;

      setReservation({
        ...defaultReservation,
        ...initialReservation,
        HotelId: hotelid,
      });

      setAgentItem(defaultReservation.Agent);
      setCompanyItem(defaultReservation.Company);
      setDefaults(hotelDefaults);
    } catch (error) {
      onError(error);
    } finally {
      loader(false);
    }
  };

  const confirmNewGuest = () => {
    return new Promise((resolve) => {
      setConfirmNewGuestElement(
        <Confirm
          open
          confirmButton={text("CreateNewGuest")}
          cancelButton={text("UpdateExisting")}
          content={text("ConfirmCreateNewGuest")}
          onConfirm={() => {
            resolve(true);
          }}
          onCancel={() => {
            resolve(false);
            setConfirmNewGuestElement(null);
          }}
        ></Confirm>
      );
    });
  };

  const handleTabChange = (e, { activeIndex }) => {
    const paymentTabIndex = panes.findIndex(p => p.key === 'payment');
    if (paymentTabIndex !== -1 && activeIndex === paymentTabIndex && !reservation.Id) {
      onWarning(message("ReservationLeftMenuFunctuanalityAvailableOnlyForSavedReservations"));
      return; // Do NOT change the active tab
    }
    setActiveTabIndex(activeIndex);
  };

  const saveAction = async (close = true) => {
    // Check if guest was edited and if there is a need to create a new guest
    const clone = { ...reservation, RenderFoliosImmediately: true };
    if (reservation.Guest && reservation.Guest.Updated) {
      if (reservation.Guest.Id.toString().startsWith("newguest-")) {
        clone.Guest.Id = 0;
        clone.GuestId = null;
      } else if (reservation.GuestId) {
        const newGuest = await confirmNewGuest();
        if (newGuest) {
          clone.Guest.Id = 0;
          clone.GuestId = null;
        }
      }
    }

    if (!checkEmailValid(guest?.Email)) {
      onWarning(message("InvalidEmail"));
      return;
    }

    try {
      setIsSaving(true);
      loader(true);
      let updated = await SaveReservation(CleanReservationProps(clone));
      /*PAY ATTENTION- currently refetching reservation from server instead of using
        the return value of saveReservation due to differences in Id capitalizations
        between OP2 and OP3 - should be changed once saveRes works with OP3 */
      updated = await GetSingleReservation(updated);

      if (paymentDialogRef.current) {
        const result = await paymentDialogRef.current.saveAction({
          folioId: updated.FolioId,
          entities: [
            {
              type: 1,
              id: updated.Id,
            },
            {
              type: 3,
              id: updated.GuestId,
            },
          ],
        });
        if (result) {
          if (result.PathOriginal) {
            saveAs(result.PathOriginal);
          }
          if (result.PathCopy) {
            saveAs(result.PathCopy);
          }
          window.postMessage({
            type: "CreditCardsUpdated",
          });
          // Clear payment selection after successful payment when staying open,
          // to prevent accidental double charge on next Save click
          if (!close) {
            paymentDialogRef.current.clearSelection();
          }
        }
      }

      if (close) {
        if (onSave) onSave([updated]);
        if (onClose) onClose();
        setGuestObj(null);
        setReservation({});
        savedReservationRef.current = null;
      } else {
        setReservation(prev => {
          const merged = { ...prev, ...updated };
          /*O3 returns PaymentTypeId; fold into the O2 casing and drop the O3 one so
            both spellings don't collide in the server's case-insensitive binder.*/
          merged.PaymentTypeID = merged.PaymentTypeID ?? merged.PaymentTypeId;
          merged.PaymentTypeId = undefined;
          return merged;
        });
        savedReservationRef.current = updated;
      }

      onSuccess();
    } catch (error) {
      console.error(error);
      error.status === 400 ? onWarning(error) : onError(error);
    } finally {
      setDisplaySave(true);
      loader(false);
      setIsSaving(false);
    }
  };

  const closeAction = () => {
    // Only call onSave if there was a successful save before closing
    if (savedReservationRef.current && onSave) {
      onSave([savedReservationRef.current]);
    }
    savedReservationRef.current = null;
    setGuestObj(null);
    setReservation({});
    if (onClose) onClose();
  };

  const recalcCheckInOutDates = (checkInDate, checkOutDate) => {
    if (checkInDate && reservation.Eta && reservation.Eta.includes(":")) {
      checkInDate.setHours(reservation.Eta.split(":")[0]);
      checkInDate.setMinutes(reservation.Eta.split(":")[1]);
    }
    if (checkOutDate && reservation.Edt && reservation.Edt.includes(":")) {
      checkOutDate.setHours(reservation.Edt.split(":")[0]);
      checkOutDate.setMinutes(reservation.Edt.split(":")[1]);
    }

    if (checkInDate && checkOutDate && checkOutDate < checkInDate) {
      checkOutDate = moment(checkInDate).add(1, "day").toDate();
      if (checkOutDate && reservation.Edt && reservation.Edt.includes(":")) {
        checkOutDate.setHours(reservation.Edt.split(":")[0]);
        checkOutDate.setMinutes(reservation.Edt.split(":")[1]);
      }
    }

    return {
      checkInDate,
      checkOutDate,
    };
  };

  const setCheckInDate = (val) => {
    const updatedDates = recalcCheckInOutDates(
      val,
      moment(reservation.CheckOutDate).toDate()
    );
    RebuildReservation(
      reservation,
      updatedDates.checkInDate,
      updatedDates.checkOutDate
    );
    setReservation({ ...reservation });
  };
  const setCheckOutDate = (val) => {
    const updatedDates = recalcCheckInOutDates(
      moment(reservation.CheckInDate).toDate(),
      val
    );
    RebuildReservation(
      reservation,
      updatedDates.checkInDate,
      updatedDates.checkOutDate
    );
    setReservation({ ...reservation });
  };

  const setReservationPax = (prop, val, reservation) => {
    val = Number(val);
    const delta = val - reservation[prop];
    reservation[prop] = val;
    if (reservation.ReservationDailyAccommodations) {
      reservation.ReservationDailyAccommodations.forEach((accomodation) => {
        accomodation[prop] = val;
      });
    }
    const addonprops = {
      Adults: "AdultQuantity",
      Children: "ChildQuantity",
      Infants: "InfantQuantity",
    };
    if (
      reservation.ReservationDailyAddons &&
      reservation.ReservationDailyAddons.length > 0
    ) {
      reservation.ReservationDailyAddons.forEach((addon) => {
        if (addon.ProductId) {
          addon[addonprops[prop]] = val;
        }
      });
      //if price type is fixed and the reservation has addons then recalc
      RecalcReservationForFixedPricesPaxChange(reservation, prop, delta);
    }

    //Resetting ReservationDailyAccommodations for the backend to re-calculate them
    reservation.ReservationDailyAccommodations = [];
  };
  const setEta = useCallback((val) => {
    setReservation((prev) => ({ ...prev, Eta: val }));
  }, []);
  const setEDT = useCallback((val) => {
    setReservation((prev) => ({ ...prev, Edt: val }));
  }, []);
  const setAdults = useCallback((val) => {
    setReservation((prev) => {
      setReservationPax("Adults", val, prev);
      return { ...prev };
    });
  }, []);
  const setChildren = useCallback((val) => {
    setReservation((prev) => {
      setReservationPax("Children", val, prev);
      return { ...prev };
    });
  }, []);
  const setInfants = useCallback((val) => {
    setReservation((prev) => {
      setReservationPax("Infants", val, prev);
      return { ...prev };
    });
  }, []);
  const setRoomType = useCallback((val) => {
    const defaultProducts =
      defaults && defaults.HotelDefaultReservationProductsViewModel;
    const product = _.find(defaultProducts, ["RoomTypeId", val]);
    setReservation((prev) => {
      return {
        ...prev,
        RoomTypeId: val,
        ProductId: product && product.ProductID,
        UpgradedFromRoomTypeID: null,
      };
    });
  }, []);
  const setRoom = useCallback((val) => {
    setReservation((prev) => {
      if (prev.ReservationDailyAccommodations) {
        _.forEach(prev.ReservationDailyAccommodations, (accomodation) => {
          accomodation.RoomId = val?.Id;
        });
      }
      return { ...prev, RoomId: val?.Id, WingId: val?.WingID };
    });
  }, []);
  const setExternalMasterID = useCallback((val) => {
    setReservation((prev) => ({ ...prev, ExternalReservationMasterId: val }));
  }, []);

  const setComments = useCallback((val) => {
    setReservation((prev) => ({ ...prev, Comments: val }));
  }, []);

  const setCommentsForGuest = useCallback((val) => {
    setReservation((prev) => ({ ...prev, CommentsVisibleToGuest: val }));
  }, []);

  const setGuest = useCallback(
    (val) => {
      if (val && val.toString().startsWith("newguest-")) {
        return;
      }
      setReservation((prev) => ({ ...prev, GuestId: val, Guest: null }));
    },
    [guest]
  );

  const setNewGuest = useCallback(
    (updated) => {
      if (updated) {
        if (!updated.FirstName || !updated.LastName) {
          onWarning("Full name is required!");
          return;
        }
        if (updated.Id.toString().startsWith("newguest-")) {
          updated.NationalityId = updated.NationalityId || defaultNationalityId;
        }
        updated.Updated = true;
        setReservation((prev) => ({
          ...prev,
          Guest: updated,
          GuestId: updated.Id,
        }));
        setGuestItem(updated);
      } else {
        setReservation((prev) => ({ ...prev, Guest: null, GuestId: null }));
        setGuestItem(null);
      }
    },
    [defaultNationalityId]
  );

  const setAgent = useCallback((val) => {
    setReservation((prev) => ({ ...prev, AgentId: val, Agent: null }));
  }, []);

  const onChangeAgentItem = useCallback((agent) => {
    setAgentItem(agent);
    setReservation((prev) => ({
      ...prev,
      PaymentArrangementId: agent?.DefaultPaymentArrangementId,
    }));
  }, []);

  const setCompany = useCallback((val) => {
    setReservation((prev) => ({ ...prev, CompanyId: val, Company: null }));
  }, []);

  const onChangeCompanyItem = useCallback((company) => {
    setCompanyItem(company);
    setReservation((prev) => ({
      ...prev,
      PaymentArrangementId: company?.DefaultPaymentArrangementId,
    }));
  }, []);

  const setVoucherNumber = useCallback((val) => {
    setReservation((prev) => ({ ...prev, VoucherNumber: val }));
  }, []);

  const setReservationSource = useCallback((val) => {
    setReservation((prev) => ({
      ...prev,
      ReservationSourceID: val,
      ReservationSource: null,
    }));
  }, []);

  const setEmail = useCallback(
    (val) => {
      const updated = guest
        ? {
          ...guest,
          Email: val,
          Updated: true,
        }
        : { Email: val, Updated: true };
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
      }));
      setGuestItem(updated);
    },
    [guest]
  );

  const setIdentityCardNumber = useCallback(
    (val) => {
      const updated = guest
        ? {
          ...guest,
          IdentityCardNumber: val,
          Updated: true,
        }
        : { IdentityCardNumber: val, Updated: true };
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
      }));
      setGuestItem(updated);
    },
    [guest]
  );
  const setPhone = useCallback(
    (val) => {
      const updated = guest
        ? {
          ...guest,
          Phone: val,
          Updated: true,
        }
        : { Phone: val, Updated: true };
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
      }));
      setGuestItem(updated);
    },
    [guest]
  );
  const setNationality = useCallback(
    (val) => {
      const updated = guest
        ? {
          ...guest,
          NationalityId: val,
          Updated: true,
        }
        : { NationalityId: val, Updated: true };
      setReservation((prev) => ({
        ...prev,
        Guest: updated,
      }));
      setGuestItem(updated);
    },
    [guest]
  );

  const setProduct = useCallback((val) => {
    setReservation((prev) => ({
      ...prev,
      ProductId: val,
      // Remove any daily values to rebuild by the server when changing product
      ReservationDailyAccommodations: [],
      ReservationDailyAddons: reservation.ReservationDailyAddons
        ? reservation.ReservationDailyAddons.filter((x) => !x.ProductId)
        : null,
    }));
  }, []);
  const setProductItem = useCallback((product) => {
    const currencyID = product
      ? product.Currency
        ? product.Currency.Id
        : product.CurrencyId
      : null;
    setReservation((prev) => ({ ...prev, CurrencyId: currencyID }));
  }, []);
  const setPricingType = useCallback((val) => {
    if (val == 4) {
      setReservation((prev) => ({
        ...prev,
        ReservationPricingTypeId: val,
        DiscountByPercent: 100,
        DiscountByAmount: getPriceBeforeDiscount(
          prev.DiscountByPercent,
          prev.TotalAmountProductCurrentBeforeTax
        ),
      }));
      setDiscountPercent(100);
    } else {
      setReservation((prev) => ({
        ...prev,
        ReservationPricingTypeId: val,
        DiscountByPercent: 0,
        DiscountByAmount: 0,
      }));
      setDiscountPercent(0);
    }
  }, []);
  // This is a simple check if any changes occured during the price recalculation that should cancel the price update
  const calc = useMemo(
    () =>
      _.debounce(async (reservation, manual) => {
        try {
          setIsReCalculating(true);
          const updated = await CalculateTotalAmountCurrentReservation({
            Reservation: {
              ...reservation,
              Guest: null,
              ReservationDailyAccommodations: [],
              ReservationDailyAddons: reservation.ReservationDailyAddons
                ? reservation.ReservationDailyAddons.filter((x) => !x.ProductId)
                : null,
              IsDayUse: moment(reservation.CheckInDate).isSame(
                reservation.CheckOutDate,
                "day"
              ),
            },
            IsReCalculateTax: true,
            IncludeCommissionCalculation: reservation.Id ? true : false,
            DigitsPercision: 8,
          });
          if (manual) {
            if (reservation.IsOverriddenTotalAmountAfterTax) {
              setReservation((prev) => {
                // If ProductId changed during price calculation than skip this update
                return prev.ProductId === reservation.ProductId
                  ? {
                    ...prev,
                    TotalAmountProductCurrentBeforeTax:
                      updated.TotalAmountProductCurrentBeforeTax,
                  }
                  : prev;
              });
            } else {
              setReservation((prev) => {
                // If ProductId changed during price calculation than skip this update
                return prev.ProductId === reservation.ProductId
                  ? {
                    ...prev,
                    TotalAmountProductCurrentAfterTax:
                      updated.TotalAmountProductCurrentAfterTax,
                  }
                  : prev;
              });
            }
          } else {
            setReservation((prev) => {
              return prev.ProductId === reservation.ProductId
                ? {
                  ...prev,
                  DiscountByPercent: updated.DiscountByPercent ?? 0,
                }
                : prev;
            });
            setDiscountPercent(updated.DiscountByPercent ?? 0);

            setReservation((prev) => {
              // If ProductId changed during price calculation than skip this update
              return prev.ProductId === reservation.ProductId
                ? {
                  ...prev,
                  TotalAmountProductCurrentBeforeTax:
                    updated.TotalAmountProductCurrentBeforeTax,
                  TotalAmountProductCurrentAfterTax:
                    updated.TotalAmountProductCurrentAfterTax,
                }
                : prev;
            });
          }
          setReservation((prev) => ({
            ...prev,
            RefetchReservation: false,
          }));
          setIsReCalculating(false);
        } catch (error) {
          console.error(error);
          error.status === 400 ? onWarning(error) : onError(error);
        } finally {
          setIsReCalculating(false);
        }
      }, 500),
    []
  );

  const setTotalPrice = (val, isAfterTax) => {
    const value = Number(val);
    const updated = {
      ...reservation,
      TotalAmountProductCurrentBeforeTax: isAfterTax
        ? reservation.TotalAmountProductCurrentBeforeTax
        : value,
      TotalAmountProductCurrentAfterTax: isAfterTax
        ? value
        : reservation.TotalAmountProductCurrentAfterTax,
      OverriddenTotalAmount: value,
      IsOverriddenTotalAmountAfterTax: isAfterTax,
      OverrideProductPrice: true,
      RefetchReservation: false,
      DiscountByPercent: 0,
    };
    setDiscountPercent(0);
    setReservation(updated);
    calc(updated, true);
  };

  const discountPercentChanged = (value) => {
    if (
      value != reservation.DiscountByPercent &&
      reservation.TotalAmountProductCurrentBeforeTax != null
    ) {
      var isBackFromFixedFreePrice =
        value == 0 && reservation.DiscountByPercent == 100;
      var originalPrice = isBackFromFixedFreePrice
        ? reservation.DiscountByAmount
        : getPriceBeforeDiscount(
          reservation.DiscountByPercent,
          reservation.TotalAmountProductCurrentBeforeTax
        );
      var amountAfterCurrentDiscount = value
        ? originalPrice - originalPrice * (value / 100)
        : originalPrice;

      const updated = {
        ...reservation,
        TotalAmountProductCurrentBeforeTax: amountAfterCurrentDiscount,
        DiscountByPercent: value,
        IsOverriddenTotalAmountAfterTax: false,
        OverrideProductPrice: true,
        RefetchReservation: false,
        OverriddenTotalAmount: amountAfterCurrentDiscount,
        DiscountTypeId: value ? 4 : null,
        DiscountByAmount: originalPrice - amountAfterCurrentDiscount,
        DiscountAuthorizedByUserId: window.user?.Id,
      };
      if (value == 100) {
        updated.ReservationPricingTypeId = 4;
        setPricingType(4);
      }
      setDiscountPercent(value);
      setReservation(updated);
      calc(updated, true);
    }
  };

  const getPriceBeforeDiscount = (percent, fullPrice) => {
    var pricePercent = (100 - percent) / percent;
    var percentOfPrice = fullPrice / (pricePercent * 100);
    return fullPrice + percentOfPrice * 100;
  };

  const ProductsSpec = React.useMemo(() => {
    return _.isEmpty(reservation) || !reservation.HotelId
      ? null
      : {
        HotelID: reservation.HotelId,
        IncludeDayPricing: true,
        IsDayUse: moment(reservation.CheckInDate).isSame(
          reservation.CheckOutDate,
          "day"
        ),
        MaxAdults: reservation.Adults,
        MaxChildren: reservation.Children,
        MaxInfants: reservation.Infants,
        RoomTypeId:
          reservation.UpgradedFromRoomTypeId || reservation.RoomTypeId,
        StartDate:
          reservation.CheckInDate && reservation.CheckOutDate
            ? moment(reservation.CheckInDate)
            : null,
        EndDate:
          reservation.CheckInDate && reservation.CheckOutDate
            ? moment(reservation.CheckOutDate)
            : null,
        AvoidAllRestriction: UserHasPermission(
          PermissionsActions.AllowSelectionOfRestrictedProducts
        ),
        IsNewAlgo: true,
        IsEnforceLeadDay: false,
      };
  }, [
    reservation.HotelId,
    reservation.Adults,
    reservation.Children,
    reservation.Infants,
    reservation.RoomTypeId,
    reservation.UpgradedFromRoomTypeID,
    reservation.CheckInDate,
    reservation.CheckOutDate,
  ]);

  const RoomTypesSpec = React.useMemo(() => {
    return _.isEmpty(reservation)
      ? null
      : {
        HotelID: reservation.HotelId,
      };
  }, [reservation.HotelId]);

  const RoomsSpec = React.useMemo(() => {
    return _.isEmpty(reservation)
      ? null
      : {
        HotelID: reservation.HotelId,
        RoomTypeIDs: reservation.RoomTypeId,
        FromAdultsMaxPax: reservation.Adults,
        FromChildrenMaxPax: reservation.Children,
        FromInfantsMaxPax: reservation.Infants,
        AvailableFrom: moment(reservation.CheckInDate).toISOString(),
        AvailableTo: moment(reservation.CheckOutDate).toISOString(),
        ExcludeInActive: true,
        IgonreReservationIDs: reservation.Id || null,
        FilterOutPlannedMaintanance: true,
      };
  }, [
    reservation.HotelId,
    reservation.RoomTypeId,
    reservation.Adults,
    reservation.Children,
    reservation.Infants,
    reservation.CheckInDate,
    reservation.CheckOutDate,
  ]);

  const AgentsSpec = React.useMemo(() => {
    return {
      CustomerTypeId: 2,
      GetOnlyCustomerArray: true,
      IsActive: true,
      IncludeCustomerProductCommission: true,
    };
  }, []);
  const CompaniesSpec = React.useMemo(() => {
    return {
      CustomerTypeId: 1,
      GetOnlyCustomerArray: true,
      IsActive: true,
      IncludeCustomerProductCommission: true,
    };
  }, []);

  const currencyFormat = (currencyID) => {
    return {
      format: "%v%s",
      symbol: Currencies[currencyID].symbol,
      locale: document.documentElement.lang || "he-IL",
    };
  };

  const productLabel = React.useCallback((item) => {
    return formatCurrency(
      item.TotalAmountAfterTax,
      currencyFormat(item.CurrencyId)
    );
  }, []);

  const currencySymbol =
    Currencies[reservation.CurrencyId ? reservation.CurrencyId : 1].symbol;

  const missingMasterId = useCallback(() => {
    if (agent && agent.ExternalChannelID) {
      return !reservation.ExternalReservationMasterId;
    } else {
      return false;
    }
  }, [agent, reservation.ExternalReservationMasterId]);

  const commisionIncompatableCurrency = useCallback(() => {
    let result = false;
    if (
      agent &&
      agent.CustomerHotelProductCommissions &&
      agent.CustomerHotelProductCommissions.length
    ) {
      agent.CustomerHotelProductCommissions.forEach((commission) => {
        result =
          result ||
          (commission.FixedCommissionAmountBeforeTax &&
            commission.FixedCommissionCurrencyID !== reservation.CurrencyId);
      });
    }
    if (
      company &&
      company.CustomerHotelProductCommissions &&
      company.CustomerHotelProductCommissions.length
    ) {
      company.CustomerHotelProductCommissions.forEach((commission) => {
        result =
          result ||
          (commission.FixedCommissionAmountBeforeTax &&
            commission.FixedCommissionCurrencyID !== reservation.CurrencyId);
      });
    }
    return result;
  }, [agent, company, reservation]);
  
  const isSaveEnabled = useMemo(() => {
    return (
      !isSaving &&
      reservation.ProductId &&
      reservation.RoomTypeId &&
      reservation.GuestId !== null &&
      reservation.GuestId !== undefined &&
      (!clubMemeberFeature ||
        reservation.Guest?.IdentityCardNumber ||
        guest?.IdentityCardNumber) &&
      !missingMasterId()
    );
  }, [
    isSaving,
    reservation.ProductId,
    reservation.RoomTypeId,
    reservation.GuestId,
    agent,
    reservation.ExternalReservationMasterId,
    reservation.Guest?.IdentityCardNumber,
    guest?.IdentityCardNumber
  ]);
 
  const fullReservation = useCallback(async () => {
    if (reservation.Id) {
      window.open(
        `${endpoint}PMS/Reservations/Index/${reservation.Id}?hotelid=${reservation.HotelId}`,
        "_blank"
      );
    } else {
      // Get Company and agent
      const customers = await GetCustomers({
        "Ids[0]": reservation.AgentId,
        "Ids[1]": reservation.CompanyId,
        GetOnlyCustomerArray: true,
      });
      const guests = await GetGuests({
        IDs: reservation.GuestId,
      });

      const reservationGuest = guests.find(
        (x) => x.Id === reservation.GuestId
      ) ||
        guest || {
        NationalityId: defaultNationalityId,
      };

      localStorage.setItem(
        "reservationViewModel",
        JSON.stringify([
          {
            // TODO - Temporary workaround until all variable names are proper camelCase
            ..._.omit(reservation, [
              "CompanyId",
              "AgentId",
              "WingId",
              "ProductId",
            ]),
            CompanyID: reservation.CompanyId,
            AgentID: reservation.AgentId,
            WingID: reservation.WingId,
            ProductID: reservation.ProductId,
            Agent: customers.find((x) => x.Id === reservation.AgentId),
            Company: customers.find((x) => x.Id === reservation.CompanyId),
            Guest: {
              // TODO - Temporary workaround until all variable names are proper camelCase
              ..._.omit(reservationGuest, "NationalityId"),
              NationalityID: reservationGuest.NationalityId,
            },
          },
        ])
      );
      window.open(
        `${endpoint}PMS/Reservations/Index/?hotelid=${reservation.HotelId}&wingId=${reservation.WingId}`,
        "_blank"
      );
    }
    setGuestObj(null);
    setReservation({});
    if (onClose) onClose();
  }, [reservation]);

  const isEditPriceAllowed = useCallback(() => {
    return (
      reservation.ReservationPricingTypeId !==
      ReservationAmountOverrideType.Free &&
      UserHasPermission(PermissionsActions.EditPrice)
    );
  }, [reservation.ReservationPricingTypeId]);

  const isUserHasPermission = useCallback((actionId) => {
    return UserHasPermission(actionId);
  }, []);

  const balance =
    reservation?.totals?.TotalAmountDebitAfterTax +
    reservation?.totals?.TotalAmountCreditAfterTax;

  const Is3dsOpenChange = (is3dsOpen) => {
    setDisplaySave(!is3dsOpen);
  };
  /* eslint-disable react/display-name */
  const panes = useMemo(() => {
    const panes = [
      {
        menuItem: isMobileOnly
          ? { icon: "edit outline" }
          : text("RequiredDetails"),
        pane: (
          <Tab.Pane as={Form} key="general">
            {isMobileOnly && (
              <Form.Field
                control={HotelsDropDown}
                spec={{ IsActive: true }}
                label={text("Hotel")}
                onChange={(id) => {
                  setReservation({
                    ...reservation,
                    HotelId: id,
                  });
                  initializeReservation();
                }}
                value={reservation.HotelId}
              />
            )}
            <Form.Group>
              <Form.Field
                width="10"
                control={GuestSearchDropDown}
                placeholder={text("SearchByNameEmailPhoneId")}
                label={text("Guest")}
                guest={reservation.Guest}
                value={reservation.GuestId}
                onAddGuest={setNewGuest}
                onChange={setGuest}
                onChangeItem={setGuestItem}
              />
              <Form.Input
                width="6"
                label={text("GuestIdentityCardNumber")}
                value={guest ? guest.IdentityCardNumber || "" : ""}
                onChange={(e, { value }) => setIdentityCardNumber(value)}
                onBlur={CheckClubMember}
                required={clubMemeberFeature}
              ></Form.Input>
              {checkingSpan && (
                <span style={{ color: "red" }}>{text("checking")}</span>
              )}
              {clubMemeberFeature && (
                <IconButton
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    alignSelf: "flex-end",
                  }}
                  onClick={CheckClubMember}
                >
                  <LocalActivity size="medium" />
                </IconButton>
              )}
            </Form.Group>
            <Form.Group>
              <Form.Input
                width="8"
                label={text("Email")}
                value={guest ? guest.Email || "" : ""}
                onChange={(e, { value }) => setEmail(value)}
              ></Form.Input>
              <Form.Input
                width="4"
                label={text("Phone")}
                value={guest ? guest.Phone || "" : ""}
                onChange={(e, { value }) => setPhone(value)}
              ></Form.Input>
              <Form.Field
                width="4"
                label={text("Nationality")}
                value={guest?.NationalityId}
                onChange={setNationality}
                clearable
                control={NationalitiesDropDown}
              />
            </Form.Group>
            <Form.Group widths="2">
              <Form.Field>
                <Form.Group unstackable className="date-pick-group">
                  <DatePicker
                    onChange={setCheckInDate}
                    label={text("Arrival")}
                    minDate={moment(businessDate).startOf("day").toDate()}
                    value={moment(
                      reservation?.CheckInDate || businessDate
                    ).toDate()}
                  />
                  <Form.Field
                    control={TimePicker}
                    label={text("ETA")}
                    style={{ minWidth: "unset" }}
                    width="6"
                    value={reservation?.Eta}
                    onChange={setEta}
                    disabled={
                      !isUserHasPermission(PermissionsActions.EditETA_ETD)
                    }
                  />
                </Form.Group>
              </Form.Field>
              <Form.Field>
                <Form.Group unstackable className="date-pick-group">
                  <DatePicker
                    onChange={setCheckOutDate}
                    label={text("Departure")}
                    minDate={moment(reservation?.CheckInDate || businessDate)
                      .startOf("day")
                      .toDate()}
                    value={
                      reservation.CheckOutDate
                        ? moment(reservation.CheckOutDate)
                          .startOf("day")
                          .toDate()
                        : moment(businessDate)
                          .startOf("day")
                          .add(1, "day")
                          .toDate()
                    }
                    pointing="right"
                  />
                  <Form.Field
                    control={TimePicker}
                    label={text("ETD")}
                    style={{ minWidth: "unset" }}
                    width="6"
                    value={reservation.Edt}
                    onChange={setEDT}
                    disabled={
                      !isUserHasPermission(PermissionsActions.EditETA_ETD)
                    }
                  />
                </Form.Group>
              </Form.Field>
            </Form.Group>
            <Form.Group widths={3} unstackable>
              <Form.Field
                label={text("Adults")}
                control={NumericInput}
                digits={0}
                buttonPlacement="right"
                value={String(reservation.Adults)}
                min={0}
                onChange={setAdults}
              />
              <Form.Field
                label={text("Children")}
                control={NumericInput}
                digits={0}
                buttonPlacement="right"
                value={String(reservation.Children)}
                min={0}
                onChange={setChildren}
              />
              <Form.Field
                label={text("Infants")}
                control={NumericInput}
                digits={0}
                buttonPlacement="right"
                value={String(reservation.Infants)}
                min={0}
                onChange={setInfants}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field
                width="9"
                label={text("RoomType")}
                required
                control={RoomTypesDropDown}
                spec={RoomTypesSpec}
                value={reservation.RoomTypeId}
                onChange={setRoomType}
                onValueNotFound={() => setRoomType(null)}
              />
              <Form.Field
                width="7"
                label={text("Room")}
                control={RoomsDropDown}
                spec={RoomsSpec}
                clearable
                value={reservation.RoomId}
                onChangeItem={setRoom}
                onValueNotFound={() => setRoom(null)}
              />
            </Form.Group>
            {!reservation.RoomId && (
              <Message warning visible>
                {text("NoRoomSelectedForReservation")}
              </Message>
            )}
            <Form.Group>
              <Form.Field
                width="9"
                control={ProductsDropDown}
                required
                label={text("Product")}
                spec={ProductsSpec}
                value={reservation.ProductId}
                descriptionField="RateName"
                labelField={productLabel}
                onChange={setProduct}
                onChangeItem={setProductItem}
                onValueNotFound={() => setProduct(null)}
              />
              <Form.Field
                width="7"
                control={PricingTypesDropDown}
                label={text("ReservationPricingType_ComboTitle")}
                search={false}
                value={reservation.ReservationPricingTypeId}
                onChange={setPricingType}
                onValueNotFound={() => setPricingType(null)}
                disabled={
                  !isUserHasPermission(PermissionsActions.EditPricingType)
                }
              />
            </Form.Group>
            {commisionIncompatableCurrency() && (
              <Message visible>
                {text("ProductCurrencyIsDifferentFromCustomerCommisison")}
              </Message>
            )}
            <Form.Group widths="3">
              <Form.Field>
                <label>{text("DiscountPercent")}</label>
                <NumericInput
                  min={0}
                  max={100}
                  digits={0}
                  disabled={!isEditPriceAllowed()}
                  loading={isRecalculating}
                  labelPosition="right"
                  value={discountPercent}
                  onChange={discountPercentChanged}
                />
              </Form.Field>
              <Form.Field>
                <label>{text("TotalPriceNotIncTax")}</label>
                <CurrencyInput
                  disabled={!isEditPriceAllowed()}
                  loading={isRecalculating}
                  labelPosition="right"
                  currency={currencySymbol}
                  value={reservation.TotalAmountProductCurrentBeforeTax}
                  onChange={(value) => setTotalPrice(value, false)}
                />
              </Form.Field>
              <Form.Field>
                <label>{text("TotalPriceIncTax")}</label>
                <CurrencyInput
                  disabled={!isEditPriceAllowed()}
                  loading={isRecalculating}
                  labelPosition="right"
                  currency={currencySymbol}
                  value={reservation.TotalAmountProductCurrentAfterTax}
                  onChange={(value) => setTotalPrice(value, true)}
                />
              </Form.Field>
            </Form.Group>
          </Tab.Pane>
        ),
      },
      {
        menuItem: isMobileOnly
          ? { icon: "sticky note outline" }
          : text("OptionalDetails"),
        pane: (
          <Tab.Pane as={Form} key="optional">
            <Form.Group widths="3">
              <Form.Field
                control={CustomerDropDown}
                clearable
                spec={AgentsSpec}
                label={text("Agent")}
                value={reservation.AgentId}
                imageField={null}
                onChange={setAgent}
                onChangeItem={onChangeAgentItem}
                onValueNotFound={() => setAgent(null)}
              />
              <Form.Field
                control={CustomerDropDown}
                clearable
                spec={CompaniesSpec}
                label={text("Company")}
                value={reservation.CompanyId}
                imageField={null}
                onChange={setCompany}
                onChangeItem={onChangeCompanyItem}
                onValueNotFound={() => setCompany(null)}
              />
              <Form.Field
                control={ReservationSourcesDropDown}
                clearable
                label={text("ReservationSources")}
                value={
                  reservation.ReservationSourceId ||
                  reservation.ReservationSourceID
                }
                onChange={setReservationSource}
                onValueNotFound={() => setReservationSource(null)}
              />
            </Form.Group>
            {commisionIncompatableCurrency() && (
              <Message visible>
                {text("ProductCurrencyIsDifferentFromCustomerCommisison")}
              </Message>
            )}
            {agent && agent.ExternalChannelID && (
              <Form.Group widths="2">
                <Form.Input
                  required
                  label={text("ExternalReservationMasterID")}
                  value={reservation.ExternalReservationMasterId}
                  onChange={(e, { value }) => setExternalMasterID(value)}
                  error={
                    missingMasterId() ? text("ExternalIDIsMandatory") : null
                  }
                />
                <Form.Input
                  label={text("VoucherCode")}
                  value={reservation.VoucherNumber}
                  onChange={(e, { value }) => setVoucherNumber(value)}
                />
              </Form.Group>
            )}
            <Form.Field
              label={text("Comments")}
              control={HtmlEditor}
              defaultValue={reservation.Comments}
              onChange={setComments}
              style={{ height: "10em" }}
            />
            <Form.Field
              label={text("MessagesForGuests")}
              control={HtmlEditor}
              defaultValue={reservation.CommentsVisibleToGuest}
              onChange={setCommentsForGuest}
              style={{ height: "10em" }}
            />
          </Tab.Pane>
        ),
      },
    ];
    const hasCCFeature =
      hotel && hotel.HotelFeatures.find((x) => x.FeatureID === 3);
    if (hasCCFeature) {
      panes.push({
        key: 'payment',
        menuItem: isMobileOnly ? { icon: "payment" } : text("PaymentMethods"),
        pane: (
          <Tab.Pane as={Form} key="payment">
            <PaymentDialog
              ref={paymentDialogRef}
              HotelId={reservation.HotelId}
              reservation={reservation}
              allowedPaymentProviderIDs={defaultAllowedPaymentProviderIDs}
              onIs3dsOpenChange={Is3dsOpenChange}
              minVal={0}
              amount={balance || reservation.TotalAmountProductCurrentAfterTax}
              readOnlyAmount={
                !isUserHasPermission(PermissionsActions.EditReceiptPrice)
              }
            ></PaymentDialog>
          </Tab.Pane>
        ),
      });
    }
    return panes;
  }, [hotel, reservation, guest, isRecalculating]);

  return (
    <Modal {...rest} size="small">
      <Modal.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {text("ShortReservation")}
        {clubMemeberFeature && (
          <ClubMemberIcon clubMemberDetails={clubMemberDetails} />
        )}
      </Modal.Header>
      <Modal.Content style={{ minHeight: 620 }} className="shortReservation">
        <Tab
          renderActiveOnly={false}
          activeIndex={activeTabIndex}
          onTabChange={handleTabChange}
          menu={{ secondary: true, pointing: true }}
          panes={panes}
        />
        {confirmNewGuestElement}
        {clubMemberPopup}
      </Modal.Content>
      {displaySave && <Modal.Actions>
        <Button disabled={isSaving} negative size='small' onClick={closeAction}>
          {' '}
          {text('Close')}
        </Button>
        <Button
          size="small"
          icon={isMobileOnly ? null : "external"}
          labelPosition={isMobileOnly ? null : "right"}
          onClick={fullReservation}
          content={text("Expand")}
        />
        <Button
          disabled={!isSaveEnabled}
          loading={isSaving}
          positive
          size="small"
          onClick={() => saveAction(true)}
        >
          {text("Saveandclose")}
        </Button>
        <Button
          disabled={!isSaveEnabled}
          loading={isSaving}
          positive
          size="small"
          onClick={() => saveAction(false)}
        >
          {text("Save")}
        </Button>
      </Modal.Actions>}
    </Modal>
  );
  /* eslint-enable react/display-name */
};

ShortReservationPopup.propTypes = {
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  reservation: PropTypes.object,
};
export default ShortReservationPopup;
